module.exports = __webpack_public_path__ + "static/img/foot.97049df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot/foot.png
// module id = 31Ki
// module chunks = 12